import { Tabs as MuiTabs, TabsProps as MuiTabsProps } from "@mui/material";
import styled from "@mui/material/styles/styled";

export type SidebarTabsProps = MuiTabsProps;

const SidebarTabs = styled(MuiTabs)(({ theme }) => ({
  minHeight: "30px",
  "& .MuiTab-root.Mui-selected": {
    background: theme.palette.shades.primary[50],
  },
  "& .MuiTabs-indicator": {
    backgroundColor: theme.palette.shades.primary[600],
  },
}));

export default SidebarTabs;
